import theme from '../../themes/theme';

const { appColors } = theme;

export default {
  titleText: {
    color: appColors.regularText,
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontSize: '1.5em',
    height: '2.125em',
    letterSpacing: '-0.03125em',
    paddingTop: '0.6375em',
  },
};
